module.exports = __webpack_public_path__ + "static/media/small-footprint-new-store-proto.fb13af0e.png";